// OSPROD-191: live NEW-ticket counts for the Tasks module — the grand total
// drives the sidebar badge on the "Tasks" rail icon; `byBoard` is consumed by
// the taskboards board-list per-board counter. NEW = unassigned + non-done.
// Kept fresh by a debounced refetch on the `taskboard:counts:changed` socket
// signal (wired in useSocket).
import { create } from 'zustand'
import { taskboardsApi } from '../services/taskboardsApi'

interface TaskCountsState {
  total: number
  byBoard: Record<string, number>
  fetch: () => Promise<void>
}

let inFlight: Promise<void> | null = null
let debounceTimer: ReturnType<typeof setTimeout> | null = null

export const useTaskCountsStore = create<TaskCountsState>((set) => ({
  total: 0,
  byBoard: {},
  fetch: async () => {
    if (inFlight) return inFlight
    inFlight = taskboardsApi
      .newCounts()
      .then((r) => set({ total: r.data.total, byBoard: r.data.byBoard }))
      .catch(() => { /* keep the last-known counts on a transient error */ })
      .finally(() => { inFlight = null })
    return inFlight
  },
}))

// A burst of item mutations can fire many `taskboard:counts:changed` events at
// once — coalesce them into a single refetch.
export function scheduleTaskCountsRefetch(): void {
  if (debounceTimer) clearTimeout(debounceTimer)
  debounceTimer = setTimeout(() => { void useTaskCountsStore.getState().fetch() }, 400)
}
